export default {
  data () {
    return {
      filterOpen: false
    }
  },

  methods: {
    toggleFilter () {
      this.filterOpen = !this.filterOpen
    }
  }
}
